// The call-to-action lists come from the api (smart-campaign/available-ctas),
// which derives them per objective from app/config/cta_config.py. Four
// hardcoded unions used to live here and were referenced by nothing - they
// could only ever drift from the server's list.
import {z} from "zod"

// cta option structure returned by api
export const cta_option_schema = z.object({
    value: z.string(),
    label: z.string()
})

export type cta_option_t = z.infer<typeof cta_option_schema>

// available ctas response from api
export const available_ctas_response_schema = z.object({
    facebook: z.array(cta_option_schema),
    linkedin: z.array(cta_option_schema),
    tiktok: z.array(cta_option_schema),
    x: z.array(cta_option_schema).optional().default([])
})

export type available_ctas_response_t = z.infer<typeof available_ctas_response_schema>

// request payload for fetching available ctas
export interface get_available_ctas_request_t {
    brand_id : number;
    objective : string;
    networks : string[];
}
